import { Permission, PERMISSIONS_BY_ROLES } from "../constants/PERMISSIONS";

export const isPermissionGranted = (roles: string[], scope: Permission | Permission[]): boolean => {
    let permissions = [];
    roles.forEach(role => {
        const rolePermissions = PERMISSIONS_BY_ROLES[role] || [];
        permissions = [...new Set([...permissions ,...rolePermissions])]; // remove duplicates
    });
    return hasPermission(permissions, scope);
}

const hasPermission = (permissions: Permission[], scope: Permission | Permission[]): boolean => {
    return Array.isArray(scope) ? scope.some(s => permissions.includes(s)) : permissions.includes(scope);
};

export const isRouteAvaiable = (roles, scope) => !scope || isPermissionGranted(roles, scope);
